module.exports = "/_next/static/images/maryam-c3ab4c1727e673a85dfc0268b4159378.jpg";